import { Helmet } from 'react-helmet-async';
// sections
import { AlbumDetails } from 'src/sections/albums/view';

// ----------------------------------------------------------------------

export default function OverviewAppPage() {
  return (
    <>
      <Helmet>
        <title> Dashboard: Album</title>
      </Helmet>

      <AlbumDetails />
    </>
  );
}
